import Loading from '@risksmart-app/components/src/loading';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import TabHeader from 'src/components/tab-header';
import {
  useInsertColourPalette,
  useUpdateColourPalette,
} from 'src/hooks/mutations/colour-palette';
import { useColourPalette } from 'src/hooks/useColourPalette';

import { ColourPaletteForm } from './ColourPaletteForm';
import type { ColourPaletteFormData } from './colourPaletteSchema';

const ColoursTab: FC = () => {
  const { t } = useTranslation('common', { keyPrefix: 'colours' });
  const { colours, loading, error, paletteId, refetch } = useColourPalette();
  const { insertColourPalette } = useInsertColourPalette();
  const { updateColourPalette } = useUpdateColourPalette();

  const onSave = async (formData: ColourPaletteFormData) => {
    if (paletteId) {
      await updateColourPalette({
        Id: paletteId,
        Name: 'Default',
        Settings: formData,
      });
    } else {
      await insertColourPalette({
        Name: 'Default',
        Settings: formData,
      });
    }
    await refetch();
  };

  if (error) {
    throw error;
  }

  return (
    <>
      <TabHeader>{t('form_title')}</TabHeader>
      {loading ? (
        <Loading testId={'loading-colours'} />
      ) : (
        <ColourPaletteForm values={{ colours }} onSave={onSave} />
      )}
    </>
  );
};

export default ColoursTab;
